import { dataHouseSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHouseSolid = /*#__PURE__*/createIcon(dataHouseSolid)
export default IconHouseSolid
